import { useEffect, useRef } from "react";

import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";

import { useTranslation } from "react-i18next";
import { GAME_INSTRUCTIONS } from "@utils/constants";

import BaseButton from "@components/Button";

import "./GameInstructionsCard.css";

const GameInstructionsCard = () => {
  const { t } = useTranslation();

  const swiperRef = useRef<Swiper | null>(null);
  useEffect(() => {
    swiperRef.current = new Swiper(".mySwiper", {
      modules: [Autoplay],
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
      on: {
        autoplayTimeLeft(swiper, _time, progress) {
          const activeProgress = document.getElementById(
            `slides-${swiper.activeIndex}`
          );
          const activePrevProgress = document.getElementById(
            `slides-${swiper.previousIndex}`
          );
          if (activeProgress) {
            activeProgress.style.opacity = "1";
          } 
          if(activePrevProgress){
            activePrevProgress.style.opacity = "0.5";
          }
        },
      },
    });
    return () => {
      swiperRef.current?.destroy();
    };
  }, []);

  return (
    <div className="swiper mySwiper pointer-events-auto w-[300px] ">
      <div className="swiper-wrapper my-3">
        {GAME_INSTRUCTIONS.map((instruction) => {
          return (
            <div
              key={instruction.id}
              className="swiper-slide flex flex-col items-center"
            >
              <img
                src={instruction.img}
                alt="instruction-img"
                className="w-full landscape:w-full mb-5"
              />
              <p className="description text-center text-md font-light p-5  bg-[#FFED45] border-2 border-[#FFB218] rounded-lg">
                {t(instruction.description)}
              </p>
            </div>
          );
        })}
      </div>
      <div className="absolute top-[250px] w-full flex items-center justify-center gap-3 z-[9999]">
        {GAME_INSTRUCTIONS.map((instruction, index) => {
          return (
            <BaseButton
              key={instruction.id}
              id={`slides-${index}`}
              className={`relative rounded-xl w-3 h-3 border-none opacity-50`}
              onClick={() => {
                swiperRef.current?.slideTo(index);
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default GameInstructionsCard;
